import {
    SuperBit_swaggerClient,
    FilterDataModel,
    BranchesModel as BranchesDataModel,
    BranchModel,
    SelectListItem,
} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

// Service wrapper for the System Management "Branches" tab.
// Replaces the old MVC Views/SystemManagement/_Branches.cshtml view and the
// BranchController/MaintenanceController endpoints it posted to
// (brachSort / brachUpsert / brachDelete / brachAdd).
export class BranchesModel {
    client: any;

    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        const url = apiUrl ? apiUrl : generalSettings.apiUrl;

        // Some generated client methods omit the Authorization header; inject it
        // here (only when absent) so every call through this client is authenticated.
        const authHttp = {
            fetch(input: RequestInfo, init?: RequestInit) {
                const token = localStorage.getItem('AuthToken');
                const headers: any = { ...(init && init.headers ? init.headers : {}) };
                if (token && !headers['Authorization']) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
                return window.fetch(input, { ...(init || {}), headers });
            },
        };

        this.client = new SuperBit_swaggerClient(url, authHttp);
    }

    // Sorted/filtered/paged branch tree (replaces _BranchItems.cshtml + _Paging.cshtml).
    // Returns a flat list of branches (each carries parentId, branchManager and
    // usersInBranch); paging is applied server-side over the top-level parents and
    // allRowsCounter is the number of top-level branches.
    async branchSort(filter: FilterDataModel): Promise<BranchesDataModel> {
        return await this.client.brachSort(filter);
    }

    // Create AND edit both post through brachUpsert (the server upserts by Id),
    // mirroring the old MVC _NewBranch form which always posted to Branch/Upsert.
    async branchUpsert(model: BranchModel): Promise<void> {
        return await this.client.brachUpsert(model);
    }

    // Deletes a branch together with all its child departments, and inactivates
    // every user that belonged to them (server-side cascade in BranchBL.Delete).
    async branchDelete(id: string): Promise<void> {
        return await this.client.brachDelete(id);
    }

    // Loads the list of users used to populate the "branch manager" dropdown in
    // the add/edit modal. brachAdd returns a fresh BranchModel whose `users` list
    // is the full user SelectList (the same list the old _NewBranch form bound to).
    // We source it from brachAdd rather than brachEdit because the generated client
    // mistypes brachEdit's response and would drop the branch fields.
    async getBranchManagers(): Promise<SelectListItem[]> {
        const model: BranchModel = await this.client.brachAdd(undefined);
        return model && model.users ? model.users : [];
    }
}
